import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Methodology.css';  // Import custom CSS file
import API_URL from '../../api/ExamCalendarApi';

const MethodologyComponent = () => {
  const [methodologies, setMethodologies] = useState([]);
  const [highlightContent, setHighlightContent] = useState('');
  const [interactiveClassesContent, setInteractiveClassesContent] = useState('');
  const [studyMaterialContent, setStudyMaterialContent] = useState('');
  const [assessmentsContent, setAssessmentsContent] = useState('');
  const [bannerImage, setBannerImage] = useState(null);
  const [interactiveClassesBanner, setInteractiveClassesBanner] = useState(null);
  const [studyMaterialBanner, setStudyMaterialBanner] = useState(null);
  const [assessmentsBanner, setAssessmentsBanner] = useState(null);
  const [editingId, setEditingId] = useState(null);  // Track which methodology is being edited

  useEffect(() => {
    fetchMethodologies();
  }, []);

  // Fetch all methodologies
  const fetchMethodologies = () => {
    axios.get(`${API_URL}/methodology/all`)
      .then(response => setMethodologies(response.data))
      .catch(error => console.error('Error fetching methodologies:', error));
  };

  // Handle form submission to add or edit a methodology
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('highlightContent', highlightContent);
    formData.append('interactiveClassesContent', interactiveClassesContent);
    formData.append('studyMaterialContent', studyMaterialContent);
    formData.append('assessmentsContent', assessmentsContent);
    if (bannerImage) formData.append('bannerImage', bannerImage);
    if (interactiveClassesBanner) formData.append('interactiveClassesBanner', interactiveClassesBanner);
    if (studyMaterialBanner) formData.append('studyMaterialBanner', studyMaterialBanner);
    if (assessmentsBanner) formData.append('assessmentsBanner', assessmentsBanner);

    if (editingId) {
      // Update existing methodology
      axios.put(`${API_URL}/methodology/edit/${editingId}`, formData)
        .then(response => {
          alert('Methodology updated successfully!');
          fetchMethodologies();
          resetForm();  // Reset form after updating
        })
        .catch(error => console.error('Error updating methodology:', error));
    } else {
      // Add new methodology
      axios.post(`${API_URL}/methodology/add`, formData)
        .then(response => {
          alert('Methodology added successfully!');
          setMethodologies([...methodologies, response.data]);
          resetForm();  // Reset form after submission
        })
        .catch(error => console.error('Error adding methodology:', error));
    }
  };

  // Reset form fields after submission or canceling edit
  const resetForm = () => {
    setHighlightContent('');
    setInteractiveClassesContent('');
    setStudyMaterialContent('');
    setAssessmentsContent('');
    setBannerImage(null);
    setInteractiveClassesBanner(null);
    setStudyMaterialBanner(null);
    setAssessmentsBanner(null);
    setEditingId(null);  // Exit editing mode
  };

  // Handle editing a methodology
  const handleEdit = (methodology) => {
    setEditingId(methodology._id);
    setHighlightContent(methodology.highlightContent);
    setInteractiveClassesContent(methodology.interactiveClassesContent);
    setStudyMaterialContent(methodology.studyMaterialContent);
    setAssessmentsContent(methodology.assessmentsContent);
    window.scrollTo(0, 0);
  };

  // Handle deleting a methodology
  const handleDelete = (id) => {
    axios.delete(`${API_URL}/methodology/delete/${id}`)
      .then(() => {
        alert('Methodology deleted successfully!');
        setMethodologies(methodologies.filter(methodology => methodology._id !== id));
      })
      .catch(error => console.error('Error deleting methodology:', error));
  };

  return (
    <>
      <div className="admin-methodology-container">
        <div className='admin-methodology-section'>
        <h2 className="admin-methodology-text-center mb-4">{editingId ? 'Edit Methodology' : 'Add Methodology'}</h2>

        <form onSubmit={handleSubmit} className="admin-methodology-form mb-5">
          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="highlightContent">Highlight Content:</label>
            <input
              id="highlightContent"
              className="admin-methodology-form-control"
              type="text"
              value={highlightContent}
              onChange={e => setHighlightContent(e.target.value)}
              required
            />
          </div>

          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="interactiveClassesContent">Interactive Classes Content:</label>
            <input
              id="interactiveClassesContent"
              className="admin-methodology-form-control"
              type="text"
              value={interactiveClassesContent}
              onChange={e => setInteractiveClassesContent(e.target.value)}
            />
          </div>

          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="studyMaterialContent">Study Material Content:</label>
            <input
              id="studyMaterialContent"
              className="admin-methodology-form-control"
              type="text"
              value={studyMaterialContent}
              onChange={e => setStudyMaterialContent(e.target.value)}
            />
          </div>

          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="assessmentsContent">Assessments Content:</label>
            <input
              id="assessmentsContent"
              className="admin-methodology-form-control"
              type="text"
              value={assessmentsContent}
              onChange={e => setAssessmentsContent(e.target.value)}
            />
          </div>

          {/* Banner image uploads */}
          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="bannerImage">Banner Image:</label>
            <input
              id="bannerImage"
              className="admin-methodology-form-control"
              type="file"
              accept="image/*"
              onChange={e => setBannerImage(e.target.files[0])}
            />
          </div>

          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="interactiveClassesBanner">Interactive Classes Banner:</label>
            <input
              id="interactiveClassesBanner"
              className="admin-methodology-form-control"
              type="file"
              accept="image/*"
              onChange={e => setInteractiveClassesBanner(e.target.files[0])}
            />
          </div>

          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="studyMaterialBanner">Study Material Banner:</label>
            <input
              id="studyMaterialBanner"
              className="admin-methodology-form-control"
              type="file"
              accept="image/*"
              onChange={e => setStudyMaterialBanner(e.target.files[0])}
            />
          </div>

          <div className="admin-methodology-form-group mb-3">
            <label htmlFor="assessmentsBanner">Assessments Banner:</label>
            <input
              id="assessmentsBanner"
              className="admin-methodology-form-control"
              type="file"
              accept="image/*"
              onChange={e => setAssessmentsBanner(e.target.files[0])}
            />
          </div>

          <button type="submit" className="admin-methodology-btn-primary">{editingId ? 'Update' : 'Submit'}</button>
          {editingId && <button type="button" className="admin-methodology-btn-secondary ms-2" onClick={resetForm}>Cancel Edit</button>}
        </form>

        <h3 className="admin-methodology-mb-4">Existing Methodologies</h3>
        <ul className="admin-methodology-list-group">
          {methodologies.map(methodology => (
            <li key={methodology._id} className="admin-methodology-list-group-item mb-3">
              <div><strong>Highlight Content:</strong> {methodology.highlightContent}</div>
              <div><strong>Interactive Classes:</strong> {methodology.interactiveClassesContent}</div>
              <div><strong>Study Material:</strong> {methodology.studyMaterialContent}</div>
              <div><strong>Assessments:</strong> {methodology.assessmentsContent}</div>
              {methodology.bannerImage && <img src={methodology.bannerImage} alt="Banner Image" className="admin-methodology-img-thumbnail my-2" />}
              {methodology.interactiveClassesBanner && <img src={methodology.interactiveClassesBanner} alt="Interactive Classes Banner" className="admin-methodology-img-thumbnail my-2" width="150" />}
              {methodology.studyMaterialBanner && <img src={methodology.studyMaterialBanner} alt="Study Material Banner" className="admin-methodology-img-thumbnail my-2" width="150" />}
              {methodology.assessmentsBanner && <img src={methodology.assessmentsBanner} alt="Assessments Banner" className="admin-methodology-img-thumbnail my-2" width="150" />}
              <div className="admin-methodology-mt-3">
                <button className="admin-methodology-btn-info me-2" onClick={() => handleEdit(methodology)}>Edit</button>
                <button className="admin-methodology-btn-danger" onClick={() => handleDelete(methodology._id)}>Delete</button>
              </div>
            </li>
          ))}
        </ul>
      </div>
      </div>
    </>
  );
};

export default MethodologyComponent;
